import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/workspace/apps/hen-site/src/component/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LegalFooter"] */ "/workspace/apps/hen-site/src/component/LegalFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/apps/hen-site/src/component/OneTrustNotice.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageIdRegistrar"] */ "/workspace/apps/hen-site/src/component/PageIdRegistrar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SignOutLink","TenantSignOutLink"] */ "/workspace/apps/hen-site/src/component/TenantSignOutLink.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/hen-ui/src/index.ts");
